import FormattedMessage from './FormattedMessage';

export default FormattedMessage;
